import { createSlice } from '@reduxjs/toolkit';
import {
  getRapportById,
  getRapports,
  deleteRapport,
  findDuplicateRapports, // Assurez-vous que l'import est bien là
} from './rapportsThunk';

// Définition de l'état initial complet
const initialState = {
  // Pour la liste principale des rapports (page de listing)
  rapports: {
    data: [],
    loading: false,
    error: null,
  },
  // Pour la page de détail d'un seul rapport
  rapportByID: {
    data: null,
    loading: false,
    error: null,
  },
  // Pour la nouvelle page de gestion des doublons
  duplicates: {
    data: [],
    loading: false,
    error: null,
  },
  // États globaux pour les actions de suppression, pour afficher le spinner sur les boutons
  deleteLoading: false,
  deleteError: null,
};

const rapportsSlice = createSlice({
  name: 'rapports',
  initialState,
  reducers: {
    // Vous pouvez ajouter des reducers synchrones ici si besoin
  },
  extraReducers: (builder) => {
    builder
      // --- Gestion de la récupération de la liste des rapports (pour la page principale) ---
      .addCase(getRapports.pending, (state) => {
        state.rapports.loading = true;
        state.rapports.error = null;
      })
      .addCase(getRapports.fulfilled, (state, action) => {
        state.rapports.loading = false;
        state.rapports.data = action.payload;
      })
      .addCase(getRapports.rejected, (state, action) => {
        state.rapports.loading = false;
        state.rapports.error = action.payload;
      })

      // --- Gestion de la récupération d'un rapport par son ID ---
      .addCase(getRapportById.pending, (state) => {
        state.rapportByID.loading = true;
        state.rapportByID.error = null;
      })
      .addCase(getRapportById.fulfilled, (state, action) => {
        state.rapportByID.loading = false;
        state.rapportByID.data = action.payload;
      })
      .addCase(getRapportById.rejected, (state, action) => {
        state.rapportByID.loading = false;
        state.rapportByID.error = action.payload;
      })

      // --- Gestion de la suppression d'un rapport ---
      .addCase(deleteRapport.pending, (state) => {
        state.deleteLoading = true;
        state.deleteError = null;
      })
      .addCase(deleteRapport.fulfilled, (state, action) => {
        state.deleteLoading = false;
        const deletedRapportId = action.payload;

        // Mise à jour de la liste principale des rapports si elle est chargée
        if (state.rapports.data && state.rapports.data.data) {
          state.rapports.data.data = state.rapports.data.data.filter(
            (rapport) => rapport.id !== deletedRapportId
          );
          // Décrémenter le nombre total d'éléments
          if (state.rapports.data.total) {
            state.rapports.data.total -= 1;
          }
        }
        
        // La mise à jour de la liste des doublons se fera par un re-fetch dans le composant,
        // ce qui est une approche plus simple et plus sûre.
      })
      .addCase(deleteRapport.rejected, (state, action) => {
        state.deleteLoading = false;
        state.deleteError = action.payload;
        console.error("Erreur lors de la suppression du rapport:", action.payload);
      })

      // ===================================================================
      // === AJOUT DE LA GESTION POUR LA RECHERCHE DES DOUBLONS ============
      // ===================================================================
      .addCase(findDuplicateRapports.pending, (state) => {
        state.duplicates.loading = true;
        state.duplicates.error = null;
      })
      .addCase(findDuplicateRapports.fulfilled, (state, action) => {
        state.duplicates.loading = false;
        state.duplicates.data = action.payload;
      })
      .addCase(findDuplicateRapports.rejected, (state, action) => {
        state.duplicates.loading = false;
        state.duplicates.error = action.payload;
        state.duplicates.data = []; // Vider les données en cas d'erreur
      });
  },
});

export default rapportsSlice.reducer;